export default new class Tabs {
  constructor() {
    this.tabsContainer = 'tabs__container';
    this.tabsActiveContainer = 'tabs__container-active';

    this.tabsBtnSelector = 'tabs__btn';
    this.tabsActiveBtnSelector = 'tabs__active';

    this.idSelector = 'data-id';

    this.clickHandler();
    this.firstTabActive();
  }

  clickHandler() {
    const btn = document.querySelectorAll(`.${this.tabsBtnSelector}`);

    if (!btn) return;

    [...btn].forEach(el => el.addEventListener('click', () => {
      this.tabHandler(el);
    }));
  }

  tabHandler(el) {
    if (el.matches(`.${this.tabsActiveBtnSelector}`)) return;

    this.id = el.getAttribute(this.idSelector);

    this.changeActiveTab(el);
    this.changeActiveContainer();
  }

  changeActiveTab(node) {
    const btn = document.querySelectorAll(`.${this.tabsBtnSelector}`);

    [...btn].forEach(el => el.classList.remove(this.tabsActiveBtnSelector));

    node.classList.add(this.tabsActiveBtnSelector);
  }

  changeActiveContainer() {
    const container = document.querySelectorAll(`.${this.tabsContainer}`);

    [...container].forEach(el => el.classList.remove(this.tabsActiveContainer));

    document.querySelector(`*[data-content="${this.id}"]`).classList.add(this.tabsActiveContainer);
  }

  firstTabActive() {
    document.addEventListener('DOMContentLoaded', () => {
      const elem = document.querySelector(`.${this.tabsBtnSelector}`);

      const eventClick = new Event('click');
      elem.dispatchEvent(eventClick);
    });
  }
}();
